<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Thông tin line
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="120px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Điểm cuối" prop="toIds">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.toIds"
                placeholder="Điểm cuối"
                size="medium"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in toPoints"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
  import uuidv4 from "uuid/v4";
  import constants from "../../../constants";
  import cauHinhLuongUtils from "../../../services/cauhinhluong/cauHinhLuongUtils";
  import h from "../../../services/h";
  import utils from "../../../services/utils";
  import CustomDialog from "../../common/custom-dialog";

  export default {
    name: "vb-step-to-step-dialog",
    components: {CustomDialog},
    props: ["isOpen", "fromPoint", "context"],

    data() {
      return {
        form: {
          toIds: null
        },
        rules: {
          toIds: null
        },
        toPoints: []
      };
    },

    created() {
      this.initComponent();
    },

    methods: {
      validateForm() {
        return utils.validateFormCommon(this.$refs.form, this.$message);
      },

      convertToSubmitForm() {
        return h.collect(this.form.toIds, toId => {
          return {
            id: uuidv4(),
            preStepId: this.fromPoint._id,
            nextStepId: toId,
            action: "Chuyển"
          };
        });
      },

      submit() {
        return this.validateForm().then(() => {
          this.$emit("submit", {forms: this.convertToSubmitForm()});
        });
      },

      buildToPoints() {
        this.toPoints = h.collect(
          //tìm tất cả các điểm chưa được nối tới không phải là nút bắt đầu, nếu fromPoint là nút bắt đầu thì loại bỏ nút kết thúc
          h.findAll(this.context.points, point => {
            return (
              !cauHinhLuongUtils.isStartPoint(point) &&
              !h.exists(
                this.context.lines,
                line => line.from === this.fromPoint._id && line.to === point._id
              ) &&
              (!cauHinhLuongUtils.isStartPoint(this.fromPoint) || !cauHinhLuongUtils.isEndPoint(point))
            );
          }),
          point => {
            return {
              id: point._id,
              label: this.getPointName(point)
            };
          }
        );
      },

      getPointName(point) {
        switch (point.type) {
          case constants.CAU_HINH_LUONG_PAGE.POINT.TYPE.START:
            return "Bắt đầu";
          case constants.CAU_HINH_LUONG_PAGE.POINT.TYPE.END:
            return "Kết thúc";
          default:
            return point.vbStepForm.stepName;
        }
      },

      initComponent() {
        this.initValidationRules();
        this.buildToPoints();
      },

      initValidationRules() {
        let defaultRequiredConstrains = utils.buildRequiredValidationConstrains();
        this.rules.toIds = [defaultRequiredConstrains];
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/setting/cau-hinh-luong-v2/vb-step-to-step-dialog.vue